import { useMemo } from "react";
import { useAuth } from "core/features/auth/store";


export function useValidatePermission() {
    const { user } = useAuth();
    const permissionSet = useMemo(() => new Set(user?.permissoes?.map(p => p.chave)), [user?.permissoes]);

    const hasPermission = (keys: string[] = [], { match = "some" } = {}) => {
        if (!keys) return false;

        const arr = Array.isArray(keys) ? keys : [keys];

        if (match === "every") {
            return arr.every((key) => permissionSet.has(key));
        }

        return arr.some((key) => permissionSet.has(key));
    };

    return { hasPermission };
}